import { api } from './api'

/*
 * ЕРАП — клиент `sc_atyrau_backend` для «Административных нарушений».
 *
 * Набор ручек тот же, что у домена «Правонарушения» витрины
 * (`sc-frontend-atyrau/src/components/sc/domain/panels/ScDomainViolations.vue`):
 * сводка протоколов, сводка и список транспорта, компании. Амнистий, субъектов
 * (физлиц), списка протоколов и решений суда (`torelik`) здесь нет: бэкенд эти
 * реестры больше не отдаёт.
 *
 * ЗЕРКАЛО ОБРЫВАЕТСЯ НА 2019 ГОДЕ — ЭТО ГЛАВНОЕ, ЧТО НАДО ЗНАТЬ.
 * Протоколов 2 024 654, но по годам последний заполненный — 2019 (38 044),
 * дальше пусто. Поэтому запросы идут БЕЗ границ периода: фильтр по сентябрю
 * 2026 возвращает ноль, и переключатель «Месяц / Квартал / Год» на этих числах
 * означал бы «данных нет», а не «нарушений не было». Подписи на экране обязаны
 * говорить «всего в зеркале», а не «за месяц».
 *
 * ПУСТЫЕ РЕЕСТРЫ НА 22.09.2026: ДТП (`accidents`), транспорт (список) — по нулю
 * записей. Заполнены протоколы и компании (10 000+).
 */

export type ErapRef = {
  id: number
  code?: string | null
  nameRu?: string | null
  nameKk?: string | null
}

export type ErapBreakdown = { ref?: ErapRef | null; count: number }

export type ErapProtocolsSummary = {
  total: number
  byDistrict: ErapBreakdown[]
  byYear: Array<{ year: number | null; count: number }>
  topArticles: ErapBreakdown[]
}

export type ErapTransportSummary = {
  totalMirrored: number
  removedTotal: number
  licenseRemoved: number
  grnsRemoved: number
  byDistrict: ErapBreakdown[]
}

/** Конверт списка. `totalIsExact: false` значит «не меньше этого». */
export type ErapPage = {
  items?: unknown[]
  data?: unknown[]
  meta: { total: number; page: number; limit: number; pages: number; totalIsExact?: boolean }
}

function qs(params: Record<string, string | number | undefined>): string {
  const pairs = Object.entries(params).filter(([, v]) => v !== undefined && v !== '')
  return pairs.length ? `?${pairs.map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`).join('&')}` : ''
}

export function fetchErapProtocolsSummary(): Promise<ErapProtocolsSummary> {
  return api.get<ErapProtocolsSummary>('/erap/protocols/summary')
}

export function fetchErapTransportSummary(): Promise<ErapTransportSummary> {
  return api.get<ErapTransportSummary>('/erap/transport/summary')
}

export function fetchErapTransport(limit = 1): Promise<ErapPage> {
  return api.get<ErapPage>(`/erap/transport${qs({ limit })}`)
}

export function fetchErapCompanies(limit = 1): Promise<ErapPage> {
  return api.get<ErapPage>(`/erap/companies${qs({ limit })}`)
}

/** Подпись значения справочника с откатом: пустая полоса читается как поломка. */
export function erapRefLabel(ref: ErapRef | null | undefined, missing = 'Не указано'): string {
  if (!ref) return missing
  return ref.nameRu?.trim() || ref.nameKk?.trim() || missing
}
